// tslint:disable:variable-name
export class BaseModel {
  public Id!: number;

  public RecordStatus!: number;

  public RowVersion!: string;
}
